module.exports = __webpack_public_path__ + "img/gear_system.4eedfa4b.png";